/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2015,2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./BaseListView',
	'../lib/@waca/core-client/js/core-client/utils/BidiUtil',
	'jquery',
	'underscore'
], function(BaseListView, BidiUtil, $, _) {

	/**
	 * Extends base list view to provide search functionality within the list view.
	 * If you extend this class you should implement the following methods
	 * @see _getSearchableItems
	 * @see _getSearchableFieldValue
	 */
	var View = BaseListView.extend({

		_setupEvents: function() {
			View.inherited('_setupEvents', this, arguments);
			this.events['click .treeSearchIcon'] = 'onSearchIconClick';
			this.events['input .treeSearchInput'] = 'onSearchTextInput';
			this.events['input input'] = 'searchTypeDelay';
		},

		_setInitialFocus: function() {
			var input = this.$('.treeSearchInput');
			BidiUtil.initElementForBidi(input[0]);
			input.focus();
		},

		/**
		 * Listens for click events to clear search text.
		 * @listens onSearchIconClick
		 */
		onSearchIconClick: function(event) {
			var icon = $(event.target);

			var shouldClear = icon.hasClass('wfg_close');

			var input = this.$el.find('.treeSearchInput');
			input.focus();

			if (shouldClear) {
				input.val('');

				// Modifing the input value does not automatically trigger the input event.
				input.trigger('input');
			}

			this._toggleCanClearSearch();
		},

		/**
		 * Listens for search text input events. Determines whether to show the clear search text icon.
		 * @listens onSearchTextInput
		 */
		onSearchTextInput: function(/* event */) {
			this._toggleCanClearSearch();
		},

		/**
		 * Determines whether the clear search icon can be displayed.
		 * @access private
		 */
		_toggleCanClearSearch: function() {
			var canClear = this._getSearchInputText().length > 0;
			this.$el.find('.treeSearchIcon').toggleClass('wfg_close', canClear);
		},

		/**
		 * Performs search request on a delay. If a new request arrives before the
		 * search is performed then the previous search is cancelled and the new
		 * request is set up on a delay.
		 * @protected
		 */

		searchTypeDelay: function( evt, sSearchText ) {

			// already have search pending so clear
			if (this.iTypeDelayTimer) {
				window.clearTimeout(this.iTypeDelayTimer);
			}
			// set up a search for 250ms after a type event stops.
			// hard to set a value here, needs to be slow enough to collect multiple key presses
			// but not too slow that the delay after typing is noticeable to the end user.
			// according to the internets the average person types at 240 characters/minute
			this.iTypeDelayTimer = window.setTimeout(this.searchData.bind(this, sSearchText || this._getSearchInputText()), 250);
		},

		/**
		 * Searches through items in this list control provided by @see _getSearchableItems
		 * Any text provided by @see _getSearchableFieldValue that contains the search text
		 * will be displayed. All other content will be removed from the view.
		 * @protected
		 */
		searchData: function(sSearchText) {
			var aRenderObjects = null;
			if (sSearchText) {

				this._isSearching = true;
				var fLabelCompare = function(value) {
					return this._getSearchableFieldValue(value).toLowerCase().indexOf(sSearchText.toLowerCase()) !== -1;
				}.bind(this);
				if (!this.isTree) {
					aRenderObjects = _.filter(this._getSearchableItems(), fLabelCompare);
				} else {
					aRenderObjects = [];
					_.each(this._getSearchableItems(), function(oItem) {
						var aChildMatches = [];
						var oClonedItem = _.clone(oItem);
						if (oItem.children) {
							aChildMatches = _.filter(oItem.children, fLabelCompare);
						}
						if (aChildMatches.length) {
							oClonedItem.children = aChildMatches;
							oClonedItem.expanded = true;
							aRenderObjects.push(oClonedItem);
						} else if (fLabelCompare(oClonedItem)) {
							oClonedItem.expanded = false;
							aRenderObjects.push(oClonedItem);
						}
					});
				}
				this._renderResultListItems(aRenderObjects);
			} else if (this._isSearching) {
				// was searching now been cleared
				this._isSearching = false;
				aRenderObjects = this._getSearchableItems();
				this._renderResultListItems(aRenderObjects);
			}
			// else wasn't searching and still not searching
			// fired by event that added to the list but
			// search filter not enabled.

		},

		/**
		 * Private method, re-renders the results of a search
		 * @private
		 */
		_renderResultListItems: function(aRenderObjects) {
			this._sortListItems(aRenderObjects);
			this.renderList(aRenderObjects);
			// render complete callback
			this.renderComplete();
		},

		/**
		 * Get the value of the search input field as a string
		 * @private
		 */
		_getSearchInputText: function() {
			return this.$el.find('.treeSearchInput').val();
		},

		/**
		 * Extenders of this class must implement this method. It should return a list of the items that are searchable
		 * @protected
		 * @abstract
		 */
		_getSearchableItems: function() {
			/* to be overrriden */
			return [];
		},

		/**
		 * Extenders of this class must implement this method. It should return a string from the given object that is to be compared against the search term. The object that is passed in will be one
		 * of the objects from the collection that was created by _getSearchableItems
		 * @protected
		 * @abstract
		 */
		_getSearchableFieldValue: function() {
			/* to be overrriden */
			return '';
		},

		/**
		 * Extenders of this class that have any special sort requirements for search results can override this method.
		 * @protected
		 * @abstract
		 */
		_sortListItems: function(aRenderObjects) {
			return aRenderObjects;
		}
	});
	return View;
});
